import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faMapMarkedAlt, faPaw, faCalendarCheck } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-scroll";

function Header() {
  return (
    <section
      className="bg-light py-5 section-full image-perro-gato"
      id="section_header"
    >
      <div className="container px-5">
        <div className="row gx-5 align-items-center justify-content-center">
          <div className="col-lg-7 col-xl-6">
            {/* Clean layout without heavy container - Minimalista */}
            <div className="my-5 text-center text-xl-start text-white animate-fade-in-up">
              
              {/* Trust Badge - More subtle */}
              <div 
                className="d-inline-flex align-items-center gap-2 mb-4 animate-fade-in-up animate-delay-100"
                style={{
                  background: 'rgba(255, 255, 255, 0.15)',
                  backdropFilter: 'blur(8px)',
                  padding: '0.5rem 1.25rem',
                  borderRadius: 'var(--radius-full)',
                  fontSize: '0.9rem',
                  fontWeight: 500,
                  border: '1px solid rgba(255, 255, 255, 0.2)'
                }}
              >
                <FontAwesomeIcon icon={faPaw} style={{ opacity: 0.9 }} />
                <span>Desde 1992 cuidando mascotas</span>
              </div>

              {/* Main Heading - Bolder and cleaner */}
              <h1 
                className="display-3 fw-bolder mb-3 text-white animate-fade-in-up animate-delay-200"
                style={{ textShadow: '0 2px 20px rgba(0,0,0,0.2)' }}
              >
                Clínica Veterinaria<br/>
                <span style={{ color: 'rgba(255, 255, 255, 0.95)' }}>Pichos</span>
              </h1>
              
              {/* Subtitle */}
              <p 
                className="lead fw-normal mb-4 animate-fade-in-up animate-delay-300" 
                style={{ 
                  fontSize: '1.35rem',
                  opacity: 0.9,
                  textShadow: '0 1px 10px rgba(0,0,0,0.15)'
                }}
              >
                Más de 30 años de experiencia al servicio de quienes más quieres
              </p>

              {/* CTA Buttons - Unified copy "Reserva tu hora" */}
              <div className="d-grid mt-4 gap-3 d-sm-flex justify-content-sm-center justify-content-xl-start animate-fade-in-up animate-delay-400">
                {/* PRIMARY CTA - Agenda Online (Green, matches brand) */}
                <a
                  className="btn btn-lg px-5 py-3"
                  href="https://www.acvet.app/agenda/reserva/5ce2627a31"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    background: 'white',
                    color: 'var(--primary-dark)',
                    fontFamily: 'var(--font-heading)',
                    fontWeight: 700,
                    fontSize: '1.1rem',
                    borderRadius: 'var(--radius-full)',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    transition: 'all 0.25s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = 'translateY(-3px)';
                    e.target.style.boxShadow = '0 8px 30px rgba(0,0,0,0.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = 'translateY(0)';
                    e.target.style.boxShadow = '0 4px 20px rgba(0,0,0,0.15)';
                  }}
                >
                  <FontAwesomeIcon icon={faCalendarCheck} className="me-2" />
                  Reserva tu hora
                </a>
                
                {/* Secondary CTA - Phone (outline style) */}
                <a
                  className="btn btn-lg px-4 py-3"
                  href="tel:+56322497632"
                  style={{
                    background: 'transparent',
                    color: 'white',
                    border: '2px solid rgba(255, 255, 255, 0.5)',
                    fontFamily: 'var(--font-heading)',
                    fontWeight: 600,
                    borderRadius: 'var(--radius-full)',
                    transition: 'all 0.25s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.background = 'rgba(255, 255, 255, 0.15)';
                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.8)';
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.background = 'transparent';
                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.5)';
                  }}
                >
                  <FontAwesomeIcon icon={faPhone} className="me-2" />
                  32 249 7632
                </a>
              </div>

              {/* Location - Subtle link */}
              <div className="mt-4 animate-fade-in-up animate-delay-500">
                <Link
                  to="section_ubicacion"
                  spy={true}
                  smooth={true}
                  offset={-50}
                  duration={500}
                  className="d-inline-flex align-items-center gap-2"
                  style={{ 
                    cursor: 'pointer',
                    color: 'rgba(255, 255, 255, 0.85)',
                    textDecoration: 'none',
                    fontSize: '1rem',
                    transition: 'color 0.2s'
                  }}
                  onMouseEnter={(e) => e.target.style.color = 'white'}
                  onMouseLeave={(e) => e.target.style.color = 'rgba(255, 255, 255, 0.85)'}
                >
                  <FontAwesomeIcon icon={faMapMarkedAlt} />
                  <span>Buenos Aires 796, Valparaíso</span>
                </Link>
              </div>
            </div>
          </div>
          
          {/* Right side - Space for background image to show */}
          <div className="col-xl-5 col-xxl-6 d-none d-xl-block"></div>
        </div>
      </div>
    </section>
  );
}

export default Header;
